module.exports = __webpack_public_path__ + "static/mustafa-95337bfc47dd663ee9aa629bb787f98f.jpeg";